import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { MatSelect } from '@angular/material';
import { PaymentService } from 'src/app/services/http/business/payment/payment.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AccountService } from 'src/app/services/http/business/account/account.service';

@Component({
  selector: 'app-subsidiary-dashboard-contract-contracts',
  templateUrl: './subsidiary-dashboard-contract-contracts.component.html',
  styleUrls: ['./subsidiary-dashboard-contract-contracts.component.css']
})
export class SubsidiaryDashboardContractContractsComponent implements OnInit {

  token = localStorage.getItem("token");
  companyList=[];
  filter:any;
  contracts=[];
  companySelected: string;
  showManagement = false;
  wallet = 0;
  nationalCode: any;
  userInfo: any;

  constructor(
    private cidService: CIDService,
    private companyService: CompanyService,
    private accountService: AccountService,
    private paymentService: PaymentService,
    private holdingService: HoldingService,
    private subsidiaryContractService: SubsidiaryContractService,
    private router: Router,
  ) { }

  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.nationalCode = decodedToken.un;
    this.userInfo = decodedToken.fname;
    this.getCompanyList();
    this.setAccess();
    this.getWallet();
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {

      this.companyList = res.DataList;
      if (this.companyList.length>=0) {
        this.getDefualtList(this.companyList[0]);
      }
   });
 }

 getDefualtList(item:any):void{
   this.cidService.setCID(item.CompanyEncryptId);
   this.companySelected=item.CompanyEncryptId;
   this.refresh();
 }
  refresh() {
    this.subsidiaryContractService.getContract(this.filter).subscribe(
      res => {

        this.contracts = res.DataList;
      }
    );
  }

  getWallet() {
    this.paymentService.getWallet(this.nationalCode).subscribe(
      res => {
        this.wallet = res.CreditCompany;
      }
    );
  }

  setAccess() {
    this.holdingService.list().subscribe(res => {
      console.log(res);

      if (res && res.Total)
        this.showManagement = true;
      // this.holdingList = res.DataList;
    });
    // this.subsidiaryContractService.getContract(null).subscribe(
    //   res => {
    //   }
    // );
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.refresh();
  }
  routToList(Id :any) : void {
    //[routerLink]="['../memorandum/'+element.Id]"
    this.router.navigate(["../subsidiary/contract/students/"+Id]);
  }
  showClasses(Id :any) : void {
    //[routerLink]="['../memorandum/'+element.Id]"
    this.router.navigate(["../subsidiary/contract/classes/"+Id]);
  }
  showFinancial(Id :any) : void {
    //[routerLink]="['../memorandum/'+element.Id]"
    this.router.navigate(["../subsidiary/contract/financial/"+Id]);
  }
  logout() {
    this.accountService.logout();
  }
}
